import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissNumberField, CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterCategoriaComunicado() {
    const { hasPermission } = usePermissionsContext();

    const [filterCodigo, setFilterCodigo] = useState<FilterValuesProps>({
        property: 'idCategoriaComunicado',
        operator: 'eq',
        value: '',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: hasPermission(['COMUNICADO_CATEGORIA_MODERAR']) ? null : true,
        idProperty: 'vlStatus',
    });

    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsCategoriaComunicado',
        operator: 'like',
        value: '',
    });

    return (
        <Filter
            filters={[
                { value: filterCodigo, setter: setFilterCodigo },
                { value: filterTitulo, setter: setFilterTitulo },
                { value: filterStatus, setter: setFilterStatus },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissNumberField
                    label="Código"
                    value={filterCodigo.value}
                    onChange={(e) => setFilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                    preventEmptyField={false}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Buscar por"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            {hasPermission(['ARQUIVO_CATEGORIA_MODERAR']) && (
                <Grid sx={{ flex: 1 }}>
                    <StatusField value={filterStatus.value} onChange={(e, value) => setFilterStatus((oldState) => ({ ...oldState, value }))} />
                </Grid>
            )}
        </Filter>
    );
}
